import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const HomeImageBanner = () => (
  <section
    className="h-80 bg-cover bg-center"
    style={{
      backgroundImage:
        'url(https://images.squarespace-cdn.com/content/v1/5be9a984f8370a38e3b406f7/1736123647190-JU8NQ71GA5YQ3K00YNC1/pexels-kxrz-2664185.jpg)',
    }}
  >
    <div className="h-full bg-black bg-opacity-40 flex items-center justify-center">
      <div className="text-center text-white px-4">
        <h2 className="text-4xl md:text-5xl font-bold mb-4">Your Favourite Wine</h2>
        <p className="text-2xl font-semibold">The way you like it!</p>
      </div>
    </div>
  </section>
);

const HomeNewsletter = ({ newsletter, setNewsletter, onSubmit, isSubmitting }) => {
  const update = (field) => (e) =>
    setNewsletter((prev) => ({ ...prev, [field]: e.target.value }));

  return (
    <>
      <HomeImageBanner />
      <section className="py-16 bg-gray-50">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Sip & Save Loyalty Program</h2>
            <p className="text-lg text-gray-700 mb-2">
              With every wine purchase you will earn points. Collect 200 points and save $10 off your next wine kit. It's that simple!
            </p>
          </div>

          <Card className="border-[#FDB913]/30 mb-6">
            <CardContent className="pt-8 pb-8 text-center">
              <div className="mb-6">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-[#FDB913]/20 rounded-full mb-4">
                  <svg className="w-10 h-10 text-[#FDB913]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Join Our Rewards Program</h3>
                <p className="text-gray-600 mb-6">
                  Sign up for our official Sip & Save loyalty program and start earning points with every purchase!
                </p>
                <a
                  href="https://squareup.com/customer-programs/enroll/JaMWYSYKP3kw?utm_medium=copied-link&utm_source=online"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                >
                  <Button
                    size="lg"
                    className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold text-lg px-8 py-6"
                  >
                    Enroll in Sip & Save Program
                  </Button>
                </a>
                <p className="text-sm text-gray-500 mt-4">Powered by Square - Secure & Easy Enrollment</p>
              </div>
            </CardContent>
          </Card>

          <div className="text-center mb-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Stay Updated</h3>
            <p className="text-gray-600">Subscribe to our newsletter for exclusive offers and wine-making tips</p>
          </div>

          <Card className="border-[#FDB913]/30">
            <CardContent className="pt-6">
              <form onSubmit={onSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <Input
                    placeholder="First Name"
                    value={newsletter.firstName}
                    onChange={update('firstName')}
                    required
                  />
                  <Input
                    placeholder="Last Name"
                    value={newsletter.lastName}
                    onChange={update('lastName')}
                    required
                  />
                </div>
                <Input
                  type="email"
                  placeholder="Email Address"
                  value={newsletter.email}
                  onChange={update('email')}
                  required
                />
                <Input
                  type="text"
                  placeholder="Referral Code (Optional)"
                  value={newsletter.referralCode}
                  onChange={update('referralCode')}
                />
                <Button
                  type="submit"
                  data-track="newsletter:home_newsletter_submit"
                  className="w-full bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Signing Up...' : 'Subscribe to Newsletter'}
                </Button>
                <p className="text-xs text-gray-500 text-center">
                  We respect your privacy. You can easily unsubscribe at any time.
                </p>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </>
  );
};

export default HomeNewsletter;
